import userService from './users.service';
import { setI18nConfig } from "@/i18n";

const getFlag = (value, env) => {
  // Caso 1: boolean directo del backend
  if (typeof value === "boolean") return value;
  // Caso 2: string del backend ("true"/"false")
  if (typeof value === "string") return value.toLowerCase().trim() === "true";
  // Caso 3: fallback a ENV
  if (typeof env === "boolean") return env;
  if (typeof env === "string") return env.toLowerCase().trim() === "true";
  return false;
};

const buildFlowFlags = (configFromDB = {}) => {
  const flow = configFromDB.flow || {};
  const ENV = process.env;

  return {
    allowPeriodicSubscriptions: getFlag(flow.ALLOW_PERIODIC_SUBSCRIPTIONS, ENV.VUE_APP_ALLOW_PERIODIC_SUBSCRIPTIONS),
    allowSendAccountWithoutOperations: getFlag(flow.ALLOW_SEND_ACCOUNT_WITHOUT_OPERATIONS, ENV.VUE_APP_ALLOW_SEND_ACCOUNT_WITHOUT_OPERATIONS),
    allowPensionPlans: getFlag(flow.ALLOW_PENSION_PLANS, ENV.VUE_APP_ALLOW_PENSION_PLANS),
    allowFiscalItems: getFlag(flow.ALLOW_FISCAL_ITEMS, ENV.VUE_APP_ALLOW_FISCAL_ITEMS),
    allowAML: getFlag(flow.ALLOW_AML, ENV.VUE_APP_ALLOW_AML),
    allowExternalCodesFromSM: getFlag(flow.ALLOW_EXTERNAL_CODES_FROM_SYSTEM_MAPPINGS, ENV.VUE_APP_ALLOW_EXTERNAL_CODES_FROM_SYSTEM_MAPPINGS),
    allowMarketerChange: getFlag(flow.ALLOW_MARKETER_CHANGE, ENV.VUE_APP_ALLOW_MARKETER_CHANGE),
    nrbeRequired: getFlag(flow.NRBE_REQUIRED, ENV.VUE_APP_NRBE_REQUIRED),
    allowEditSubdistributor: getFlag(flow.ALLOW_EDIT_SUBDISTRIBUTOR, ENV.VUE_APP_ALLOW_EDIT_SUBDISTRIBUTOR),
    allowAutoClassSelection: getFlag(flow.ALLOW_AUTO_CLASS_SELECTION, ENV.VUE_APP_ALLOW_AUTO_CLASS_SELECTION),

    s3Path: configFromDB.s3_path || null,
    defaultDistributorUuid: configFromDB.default_distributor_uuid || null
  };
};

function setStyles(styles) {
  const root = document.documentElement;
  const rootStyles = root.style;
  Object.entries(styles).forEach(data => {
    const [key, value] = data;
    if (key === 'logo') {
      const styleSheet = document.styleSheets[0] || document.head.appendChild(document.createElement('style')).sheet;

      const cssRule = `.customLogo {
                        width: 100%;
                        height: auto;
                        background-image: url(${value});
                        background-size: contain;
                        background-position: center;
                        background-repeat: no-repeat;
                      }`;

      styleSheet.insertRule(cssRule, styleSheet.cssRules.length);
    }
    rootStyles.setProperty(`--${key}`, `${value}`);
  });
}

function setTagManager(tagManager) {
  if (process.env.VUE_APP_USERSTORE_PREFIX === 'PRO') {
    if (!tagManager) return;

    const scriptTag = document.createElement("script");
    scriptTag.async = true;
    scriptTag.src = `https://www.googletagmanager.com/gtag/js?id=${tagManager}`;
    document.head.appendChild(scriptTag);
  
    scriptTag.onload = () => {
      window.dataLayer = window.dataLayer || [];
      function gtag() { window.dataLayer.push(arguments); }
      window.gtag = gtag;
      gtag("js", new Date());
      gtag("config", tagManager);
    };
  }
}

const defaultConfigUuid =
  process.env.VUE_APP_ENTITY_UUID || "5271fc2d-f79c-4e25-bf50-31625b337c01";

export async function setEntityConfig(store) {
  const urlParams = new URLSearchParams(window.location.search);
  const id =
    urlParams.get("id") || localStorage.getItem("OBENST") || defaultConfigUuid;

  let s3Path, languajes;

  if (id) {
    const res = await userService.getPublicConfiguration(id);

    if (
      res.data &&
      res.data.configuration &&
      res.data.configuration.initial_configuration
    ) {
      const configFromDB = res.data.configuration.initial_configuration;
      const configStyle = configFromDB.styles;
      s3Path = configFromDB.s3_path;
      languajes = configFromDB.languajes;
      const obPath = configFromDB.onboarding_path;
      const tagManager = configFromDB.tag_manager_bo;

      const flowFlags = buildFlowFlags(configFromDB);
      store.dispatch("configVarsStore/setFlowFlags", flowFlags);

      console.log('store', store)
      

      localStorage.setItem("BOPLCM", btoa(configFromDB.crm_mimetype));
      localStorage.setItem("BOPLEN", res.data.configuration.uuid);
      localStorage.setItem("BOPLFT", JSON.stringify(configFromDB.file_types));
      localStorage.setItem("OBPATH", obPath);

      if (configStyle) setStyles(configStyle);
      if (tagManager) setTagManager(tagManager);
      if (s3Path) await setI18nConfig(s3Path, languajes);
      
      store.dispatch("setLanguajes", languajes);
    }
  }

  return { s3Path, languajes };
}